import { render, staticRenderFns } from "./extra.vue?vue&type=template&id=ae728e7c&scoped=true"
import script from "./extra.vue?vue&type=script&lang=js"
export * from "./extra.vue?vue&type=script&lang=js"
import style0 from "./extra.vue?vue&type=style&index=0&id=ae728e7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae728e7c",
  null
  
)

export default component.exports